import '../../legend.css';
import '../../main.css';
import '../../main-desktop.css';
import '../../icons.css';

// Bootstrap
import "bootstrap-icons/font/bootstrap-icons.css";
import bootstrapBundleMin from '../../../public/lib/js/bootstrap.bundle.min.js';

// Navbar
import {
    closeNavbar,
    attachDropdownListeners
} from '../navbar/navbar';

import '../navbar/navbar';

// Queries

import {
    districtFetchTableData
} from '../../queries/fetch-table-data';

// Helpers

import {
    createButtonTabs
} from './helpers/create-tab-btn';

import {
    toDDMonFormatAEST
} from './helpers/header-format-date';

import {
    createRegionRows
} from './helpers/create-region-rows';

// ! GLOBAL VARIABLES

let selectedDay; // The currently selected day
let daysMap;
let tableData;

// ! Listeners

// ! Handlers

/**
 * Handles displayed the various available data based on the
 * forecasted day.
 * @param {*} tableData Unused 
 * @param {*} option The day that was clicked (should be a string
 *  like 'May 01')
 * @param {*} daysMap The map of day keys ('May 01') to indexes (0,1,2,...) 
 */
const btnClickHandler = (tableData, option, daysMap) => {
    // Set all the buttons to 
    const headerBtns = $(`[id$='-header-btn-id']`);
    headerBtns.removeClass('header-btn-style-on');
    headerBtns.addClass('header-btn-style');

    selectedDay = daysMap[option];

    // Set the button that was clicked to 'on'
    const newSelectedBtn = $(`#${selectedDay}-header-btn-id`);
    newSelectedBtn.removeClass('header-btn-style');
    newSelectedBtn.addClass('header-btn-style-on');

    // Generate the new table
    generateTable();
}

/**
 * Prints the current page
 */
const printBtnHandler = () => {
    window.print();
}

// ! Helpers

const showLoadingUI = () => {
    const loadingSpinner = $(`#loading-spinner-id`);
    loadingSpinner.empty();
    const loadingUI = $(`<div class="loading-spinner-container">` + 
        `<div class="spinner-grow text-primary" role="status">` + 
            `<span class="visually-hidden">Loading...</span>` +
        `</div>` +
    `</div>`);
    loadingSpinner.append(loadingUI);
}

const hideLoadingUI = () => {
    const loadingSpinner = $(`#loading-spinner-id`);
    loadingSpinner.empty();
}

/**
 * Generates the table with all the items
 */
const generateTable = () => {
    // Show the loading UI
    const tableContainer = $('#table-container-id');
    tableContainer.empty();

    const newTable = $(`<table class="table ui-table-container-style table-striped"></table>`);

    // Get the current data
    createRegionRows(tableData, selectedDay, newTable);

    tableContainer.append(newTable);
}

/**
 * Generates the buttons displayed along the top of the table.
 */
const generateHeaderBtns = (result) => {
    let days = [];
    let reverseDayMap = {};

    for(var i = 0; i < result.summary.length; i++) {
        // Format the date
        const formattedDay = toDDMonFormatAEST(result.summary[i].forecast_start);
        days.push(formattedDay);
        reverseDayMap[formattedDay] = i;
    }

    if (selectedDay === undefined && days.length > 0) {
        selectedDay = reverseDayMap[days[0]];
    }

    // Set the currently selected day
    daysMap = reverseDayMap;
    tableData = result;

    // Generate the date and print buttons
    createButtonTabs(result, days, selectedDay, reverseDayMap, btnClickHandler, printBtnHandler);
    generateTable();
}

// ! MAIN

$(window).on("load", function() {
    // Load in the navbar dynamically (this is 
    // how we reuse components in ancient times)
    $("#fwv-navbar-id").load("navbar.html", function() {
        attachDropdownListeners();
    });

    // Set the loading UI
    showLoadingUI();

    // Fetch the table data
    
    districtFetchTableData().then((result) => {
        // Generate the header buttons (this will also trigger the
        // generation of the table)
        generateHeaderBtns(result);
        
        // Remove the loading UI
        hideLoadingUI();
    });
});